import React from 'react';
import { Grid } from '@mui/material';

import {
	BooleanDescField,
	SearchSelectField,
	SimpleTextField,
	TagsSelectField,
	useSettings,
	Utils
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function OrdersDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { sysSettings, t } = useSettings();

	const isBeB = Utils.getConnectionFromToken() === 'PERCEPTIVE_CONTROL_BEB';

	return (
		<>
			{/* PRICING GROUP */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="ords_pric_id"
					label={t('DETAILS_ORDERS_FIELD_PRICINGGROUP')}
					systable="pricinggroups"
					filters={
						isBeB && props.model.comp_core_id !== 2
							? [{ filt_field: 'pric_id', filt_clause: 'in', filt_value: [2] }]
							: undefined
					}
					value={props.model.ords_pric_id}
					isEdit={props.isEdit && (isBeB ? props.model.comp_core_id !== 2 : true)}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* DISCOUNT GROUP */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="ords_disc_id"
					label={t('DETAILS_ORDERS_FIELD_DISCOUNTGROUP')}
					systable="discountgroups"
					filters={
						isBeB && props.model.comp_core_id !== 2
							? [{ filt_field: 'disc_id', filt_clause: 'in', filt_value: [11, 17, 20] }]
							: undefined
					}
					value={props.model.ords_disc_id}
					isEdit={props.isEdit && (isBeB ? props.model.comp_core_id !== 2 : true)}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* PAYMENT TERMS */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="ords_pate_id"
					label={t('DETAILS_ORDERS_FIELD_PAYMENTTERMS')}
					systable="paymentterms"
					value={props.model.ords_pate_id}
					isEdit={props.isEdit && !isBeB}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* PAYMENT METHOD */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="ords_pame_id"
					label={t('DETAILS_ORDERS_FIELD_PAYMENTMETHOD')}
					systable="paymentmethods"
					value={props.model.ords_pame_id}
					isEdit={props.isEdit && !isBeB}
					sendChange={props.sendChange}
				/>
			</Grid>
			{sysSettings.orders_shipping_enabled === 'true' ? (
				<>
					{/* SHIPPING METHOD */}
					<Grid size={{ sm: 6, xs: 12 }}>
						<SearchSelectField
							name="ords_shme_id"
							label={t('DETAILS_ORDERS_FIELD_SHIPPINGMETHOD')}
							systable="shippingmethods"
							value={props.model.ords_shme_id}
							isEdit={props.isEdit && !isBeB}
							sendChange={props.sendChange}
						/>
					</Grid>
					{/* SHIPPING AGENT */}
					<Grid size={{ sm: 6, xs: 12 }}>
						<SearchSelectField
							name="ords_shag_id"
							label={t('DETAILS_ORDERS_FIELD_SHIPPINGAGENT')}
							systable="shippingagents"
							value={props.model.ords_shag_id}
							isEdit={props.isEdit && !isBeB}
							sendChange={props.sendChange}
						/>
					</Grid>
				</>
			) : (
				<></>
			)}
			{/* EXTERNAL NUMBER */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="ords_externalnumber"
					label={t('DETAILS_ORDERS_FIELD_EXTERNAL_NUMBER')}
					value={props.model.ords_externalnumber}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					validations={{ maxLength: 35 }}
					validationErrors={{
						maxLength: t('ERROR_TEXT_MAXLENGTH')
					}}
				/>
			</Grid>
			{/* TAGS */}
			{/* <Grid size={12}>
				<TagsSelectField
					name="ords_tags"
					label={t('DETAILS_ORDERS_FIELD_TAGS')}
					value={props.model.ords_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* WARNING */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<BooleanDescField
					name="ords_warning_desc"
					label={t('DETAILS_ORDERS_FIELD_WARNING')}
					value={props.model.ords_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* BLOCKED */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<BooleanDescField
					name="ords_blocked_desc"
					label={t('DETAILS_ORDERS_FIELD_BLOCKED')}
					value={props.model.ords_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
		</>
	);
}
